<template>
  <div class="main">
    <section class="form-wrapper">
      <div class="logo-box"></div>
      <div class="form-box">
        <div class="box-title">
          <p class="box-title-text">企业形象从此开始</p>
        </div>
        <a-form
          id="formLogin"
          class="user-layout-login"
          ref="formLogin"
          :form="form"
          @submit="handleSubmit"
        >
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入用户名"
              v-decorator="[
                'username',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入帐户名'
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="user"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="请输入密码"
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请输入密码' }],
                  validateTrigger: 'blur'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-checkbox :checked="checkAutoLogin" @change="handleChange"
              >下次自动登录</a-checkbox
            >
          </a-form-item>

          <a-form-item style="margin-top:24px">
            <a-button
              size="large"
              type="primary"
              htmlType="submit"
              class="login-button"
              :loading="state.loginBtn"
              :disabled="state.loginBtn"
              >登录</a-button
            >
          </a-form-item>
        </a-form>
      </div>
    </section>
  </div>
</template>

<script>
import md5 from 'md5'
import { timeFix } from '@/utils/util'
// import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
// import { getSmsCaptcha, get2step } from '@/api/login'

export default {
  components: {
    // TwoStepCaptcha
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      },
      checkAutoLogin: false, // 自动登录

      // TODO
      usernameExist: true
    }
  },

  methods: {
    ...mapActions(['Login', 'Logout']),

    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        Login
      } = this

      state.loginBtn = true

      const validateFieldsKey = ['username', 'password']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const loginParams = { ...values }
          loginParams.password = md5(values.password)
          loginParams.autoLogin = this.checkAutoLogin
          Login(loginParams)
            .then(res => this.loginSuccess(res))
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    loginSuccess() {
      this.$router.push({ path: '/' })
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      // this.isLoginError = false
    },
    getCaptcha(e) {
      e.preventDefault()
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {},
    handleChange(e) {
      this.checkAutoLogin = e.target.checked
      //this.$nextTick(() => {
      //  this.form.validateFields(['nickname'], { force: true });
      //});
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 940px;
  height: 428px;
  margin: 100px auto;
  .form-wrapper {
    width: 940px;
    height: 428px;
    display: flex;
    background-color: #ffffff;
    .logo-box {
      width: 520px;
      height: 100%;
      background-image: url(./components/img/bg_login.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .form-box {
      width: 402px;
      height: 100%;
      padding: 20px;
      .box-title {
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #333333;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 27px;
        .box-title-text {
          margin-bottom: 5px;
        }
      }
    }
  }
}
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
